var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"dashboard-index",attrs:{"align-center":"","justify-center":""}},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":"/static/img/logo.png","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }